(ns story-builder.story-editor.layer.util
  (:require
   [re-frame.core :as rf]
   [story-builder.story-editor.animation-sidebar.sub :as animation-sidebar.sub]
   [story-builder.story-editor.animation-sidebar.util :as animation-sidebar.util]
   [story-builder.story-editor.rich-text.content :as rich-text.content]
   [story-builder.util.core :as util]))

(defn set-layer-background-color
  [layer colour alpha {:keys [related-action] :as related}]
  (cond-> (assoc-in layer [:layer-style :background-color] colour)
    (zero? alpha) (assoc-in [:layer-classes :background-color] "is-background--transparent")
    (not= alpha 0) (assoc-in [:layer-classes :background-color] "is-background--solid")
    related (assoc-in [:layer-classes :related] (when related-action "is-sameBackground"))))

(defn animation
  [{:keys [animations animation layer-style id]}
   child]
  (let [animations-enabled? @(rf/subscribe [::animation-sidebar.sub/animations-enabled? id])
        animations-by-id    @(rf/subscribe [::animation-sidebar.sub/animations-by-id])
        animation-vars      @(rf/subscribe [:ui/animation-vars id])
        story-type          @(rf/subscribe [:story/story-type])]
    (if (and (or animations animation)
             animations-enabled?)
      (if animations
        (let [animations @(rf/subscribe [::animation-sidebar.sub/enabled-animations animations])]
          (if (seq animations)
            [animation-sidebar.util/wrap-with-animations (merge {:layer-animations       animations
                                                                 :scene-animations-by-id animations-by-id}
                                                                {:vars animation-vars})
             child]
            child))
        [:span
         (merge
          {:style                  (merge (-> layer-style
                                              (select-keys [:animation-delay :animation-duration])
                                              (util/append-to-vals "s"))
                                          (select-keys layer-style [:animation-timing-function])
                                          (when (not= story-type "branded")
                                            (animation-sidebar.util/animation-vars {:animation {:animation animation}
                                                                                    :vars      animation-vars})))
           :data-animation         animation
           :data-animation-version 1}
          (when (map? child) child))
         (when (vector? child) child)])
      child)))

(defn content-text [content]
  (cond
    (string? content)
    (util/strip-html content)
    (vector? content)
    (rich-text.content/content-text content)))

(defn content-font-ids [content]
  (mapcat (fn [block]
            (->> block
                 (tree-seq map? :children)
                 (mapcat (fn [node]
                           (let [direct   (some-> node :font-id)
                                 bp-fonts (some->> node :breakpoint vals (keep :font-id))]
                             (cond-> []
                               direct (conj direct)
                               (seq bp-fonts) (into bp-fonts)))))))
          content))

(defn text-layer-type? [layer-type]
  (contains? #{"title" "subheading" "text" "author" "date" "rich-text" "captions"} layer-type))

(defn font-ids [layer]
  (let [amp-paths      [[:prompt]
                        [:option]
                        [:all]
                        [:result-prompt]
                        [:result-category]
                        [:result-description]]
        content-fonts  (when (vector? (:content layer))
                         (content-font-ids (:content layer)))
        amp-fonts      (for [path  amp-paths
                             :let  [font-id (get-in layer (concat [:amp] path [:font-id]))]
                             :when font-id]
                         font-id)
        option-fonts   (when-let [options (get-in layer [:amp :options])]
                         (let [font-ids (->> options
                                             (keep (fn [opt]
                                                     (:font-id opt (get-in opt [:style :font :id])))))]
                           (if (and (seq options) (empty? font-ids))
                             ["6c636fae-8e4b-11f0-96d0-b7fbbdadcee6"]
                             font-ids)))
        layer-font     (when-let [font-id (:font-id layer)]
                         [font-id])
        layer-hover    (when-let [font-id (get-in layer [:hover :font-id])]
                         [font-id])
        layer-bp-fonts (some->> layer :breakpoint vals (keep :font-id))
        layer-bp-hover (some->> layer :breakpoint vals (keep #(get-in % [:hover :font-id])))]
    (concat content-fonts amp-fonts option-fonts layer-font layer-hover layer-bp-fonts layer-bp-hover)))

(comment
  (font-ids {:font-id "A font ID"
             :content [{:children
                        [{:data-font-id "1c80fbdb-b2f4-11eb-ac5c-bff969b462d2"
                          :style        {:font-family "Abril Normal",
                                         :font-size   "1.6875em"},
                          :text         "Here"}
                         {:style {:font-family "Abril Normal"
                                  :font-size   "1.6875em"
                                  :opacity     "1"},
                          :text  " is one block."}],
                        :style {:text-align "right"},
                        :tag "h2"}
                       {:children [{:data-font-id "363bf38a-b30c-11eb-aace-f45e8e84f6b8"
                                    :style        {:font-family "Acumin Pro Condensed Normal",
                                                   :font-size   "1.125em"},
                                    :text         "Here is another block."}],
                        :style {:text-align "right"},
                        :tag "p"}]}))

(defn text-vertical-align-transform
  [text-vertical-align transform]
  (str (case text-vertical-align
         :top "translateX(-50%) translateY(0)"
         :bottom "translateX(-50%) translateY(-100%)"
         "translateX(-50%) translateY(-50%)")
       (when transform
         (when-let [deg (-> (re-matches #".*rotate\((.+)deg\)" transform)
                            (second))]
           (str " rotate(" deg "deg)")))))

(def bento-twitter-embeds (atom #{}))

(add-watch bento-twitter-embeds :watcher
           (fn [_ _ _ new-state]
             (when (empty? new-state)
               (doseq [el (js/document.querySelectorAll "[data-bento-twitter='true']")]
                 (.remove el)))))
